export default "__VITE_ASSET__BsCVX3SX__"